import React, { FC } from 'react';

import { EventSummaryType } from './EventListPanel';
import { InlineIcon } from '@spark-labs/avocado-ui';

export interface EventListPanelRowProps {
  locked: boolean;
  highlighted: boolean;
  eventType: EventSummaryType;
  time: string;
  title: string;
  venue: string;
  hidden: boolean;
  onMouseEnter: () => void;
  onEventHideClick: () => void;
  onEventTitleClick: () => void;
}

function getEventColor(eventType: EventSummaryType, highlighted: boolean) {
  return eventType === 'event'
    ? `${highlighted ? 'bg-blue-lightest' : 'bg-yellow-lightest'} text-grey-dark`
    : 'bg-purple-darker text-white';
}

function getEventIcon(eventType: EventSummaryType, highlighted: boolean, hidden: boolean) {
  if (eventType === 'groupEvent') {
    return <InlineIcon name={'group'} className="w-4 h-4" />;
  } else if (hidden) {
    return <InlineIcon name={'no-eye'} className="w-4 h-4" />;
  } else if (highlighted) {
    return <InlineIcon name={'eye'} className="w-4 h-4" />;
  }
}

const EventListPanelRow: FC<EventListPanelRowProps> = ({
  eventType,
  locked,
  highlighted,
  onMouseEnter,
  onEventHideClick,
  onEventTitleClick,
  time,
  title,
  venue,
  hidden,
}) => {
  let eventColor = getEventColor(eventType, highlighted);
  let eventIcon = getEventIcon(eventType, highlighted, hidden);
  let isEventClickable = !locked && eventType === 'event';
  return (
    <li
      className={`border-b border-white leading-loose pl-3 flex
items-center ${eventColor}`}
      onMouseEnter={onMouseEnter}
    >
      <a className="cursor-pointer" onClick={isEventClickable ? onEventTitleClick : undefined}>
        <span className="whitespace-no-wrap">{time}</span>
      </a>
      <div className="mx-3 w-6">
        {eventIcon && (
          <a className="cursor-pointer" onClick={isEventClickable ? onEventHideClick : undefined}>
            {eventIcon}
          </a>
        )}
      </div>
      <a className="cursor-pointer" onClick={isEventClickable ? onEventTitleClick : undefined}>
        <span className="font-bold mr-1 leading-normal">{title},</span>{' '}
        <span className="leading-normal">{venue}</span>
      </a>
    </li>
  );
};

export default EventListPanelRow;
